import { render, staticRenderFns } from "./SharePayLink.vue?vue&type=template&id=5979fd74&scoped=true"
import script from "./SharePayLink.vue?vue&type=script&lang=js"
export * from "./SharePayLink.vue?vue&type=script&lang=js"
import style0 from "./SharePayLink.vue?vue&type=style&index=0&id=5979fd74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5979fd74",
  null
  
)

export default component.exports